import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "65",
  height: "64",
  fill: "none",
  viewBox: "0 0 65 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#1AA570\" d=\"M50.07 26.85h-2v-5.56c0-6.77-5.51-12.28-12.28-12.28s-12.28 5.51-12.28 12.28v5.56h-2v-5.56c0-7.88 6.41-14.28 14.28-14.28s14.28 6.41 14.28 14.28z\"></path><path fill=\"#1AA570\" d=\"M19.5 27.61h-2v-6.32c0-7.88 6.41-14.28 14.28-14.28h3.52v2h-3.52c-6.77 0-12.28 5.51-12.28 12.28z\"></path><path fill=\"#1AA570\" d=\"M18.5 26h28c4.42 0 8 3.58 8 8v20h-36z\"></path><path fill=\"#FFE8CC\" d=\"M26.5 26h20c4.42 0 8 3.58 8 8v20h-36V34c0-4.42 3.58-8 8-8\"></path><path fill=\"#1AA570\" d=\"M18.5 26c-4.42 0-8 3.58-8 8v20h8z\"></path><path fill=\"#1AA570\" d=\"M54.5 34h-44v2h44zM54.5 44h-44v2h44z\"></path>", 6)
  ])))
}
export default { render: render }